
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BackofficeLayout from "@/components/layouts/BackofficeLayout";
import { UnderlinedTabs, UnderlinedTabsList, UnderlinedTabsTrigger, UnderlinedTabsContent } from "@/components/ui/underlined-tabs";
import DocumentTypesSettings from "@/components/settings/DocumentTypesSettings";
import RolesSettings from "@/components/settings/RolesSettings";
import FinanceSettings from "@/components/settings/FinanceSettings";

const Settings = () => {
  const [activeTab, setActiveTab] = useState("document-types");
  const location = useLocation();

  useEffect(() => {
    // Get the tab from URL query parameters
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    if (tab) {
      setActiveTab(tab);
    } else {
      // Default to document-types tab
      setActiveTab("document-types");
    }
  }, [location.search]);

  return (
    <BackofficeLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Settings</h1>
          <p className="text-gray-500">
            Manage application-wide settings and configurations
          </p>
        </div>

        <UnderlinedTabs
          defaultValue="document-types"
          value={activeTab}
          onValueChange={setActiveTab}
          className="w-full"
        >
          <UnderlinedTabsList>
            <UnderlinedTabsTrigger value="document-types">
              Document Types
            </UnderlinedTabsTrigger>
            <UnderlinedTabsTrigger value="roles">
              Roles
            </UnderlinedTabsTrigger>
            <UnderlinedTabsTrigger value="finance">
              Finance
            </UnderlinedTabsTrigger>
          </UnderlinedTabsList>

          <UnderlinedTabsContent value="document-types">
            <DocumentTypesSettings />
          </UnderlinedTabsContent>
          <UnderlinedTabsContent value="roles">
            <RolesSettings />
          </UnderlinedTabsContent>
          <UnderlinedTabsContent value="finance">
            <FinanceSettings />
          </UnderlinedTabsContent>
        </UnderlinedTabs>
      </div>
    </BackofficeLayout>
  );
};

export default Settings;
